(function () {
  var STORAGE_KEY = 'rbk-recently-viewed';

  function readHandles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  function writeHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (err) {
      // localStorage unavailable (private browsing, quota, disabled) —
      // recently viewed just won't persist; nothing else depends on it.
    }
  }

  // Moves the current handle to the front (or inserts it) rather than
  // appending, so re-visiting a product bumps it back to "most recent"
  // instead of leaving a stale, older entry sitting in the list too.
  function recordView(handle, maxProducts) {
    if (!handle) return;
    var handles = readHandles().filter(function (existing) {
      return existing !== handle;
    });
    handles.unshift(handle);
    if (handles.length > maxProducts) {
      handles = handles.slice(0, maxProducts);
    }
    writeHandles(handles);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function formatMoney(cents, currency) {
    var amount = (cents / 100).toFixed(2);
    return currency ? currency + ' ' + amount : amount;
  }

  function absoluteImageUrl(src) {
    if (!src) return '';
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  // Builds one <li> the same shape SliderComponent (global.js) expects —
  // [id^="Slide-"], since it re-scopes to that selector whenever this
  // grid's content changes.
  function buildCardHtml(product, currency, slideIndex) {
    var image = absoluteImageUrl(product.featured_image || (product.images && product.images[0]));
    var priceHtml = formatMoney(product.price, currency);
    if (typeof product.compare_at_price === 'number' && product.compare_at_price > product.price) {
      priceHtml =
        '<s class="recently-viewed-card__compare-price">' +
        formatMoney(product.compare_at_price, currency) +
        '</s> ' +
        priceHtml;
    }

    return (
      '<li id="Slide-recently-viewed-' +
      slideIndex +
      '" class="grid__item slider__slide">' +
      '<a href="' +
      escapeHtml(product.url) +
      '" class="recently-viewed-card">' +
      '<span class="recently-viewed-card__media">' +
      '<img src="' +
      escapeHtml(image) +
      '" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy" class="recently-viewed-card__img">' +
      '</span>' +
      '<span class="recently-viewed-card__title">' +
      escapeHtml(product.title) +
      '</span>' +
      '<span class="recently-viewed-card__price">' +
      priceHtml +
      '</span>' +
      '</a>' +
      '</li>'
    );
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function initRecentlyViewed(root) {
    var currentHandle = root.dataset.currentHandle;
    var currency = root.dataset.currency;
    var maxProducts = parseInt(root.dataset.maxProducts, 10) || 12;
    var slider = root.querySelector('.discover__slider');
    var grid = root.querySelector('.discover__grid');
    if (!slider || !grid) return;

    // Recorded before filtering it back out of what gets displayed below —
    // otherwise this page's own product would never make it into the list
    // shown on the NEXT product page visited.
    recordView(currentHandle, maxProducts);

    var handles = readHandles().filter(function (handle) {
      return handle !== currentHandle;
    });
    if (!handles.length) return;

    Promise.all(handles.map(fetchProduct))
      .then(function (products) {
        var cardsHtml = products
          .filter(Boolean)
          .map(function (product, index) {
            return buildCardHtml(product, currency, index + 1);
          })
          .join('');

        if (!cardsHtml) return;

        grid.innerHTML = cardsHtml;
        slider.hidden = false;
        if (typeof slider.resetPages === 'function') {
          slider.resetPages();
        }
      })
      .catch(function (err) {
        console.error('[recently-viewed] Failed to load recently viewed products:', err);
      });
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(initRecentlyViewed);
})();
